function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 10.25c-.41 0-.75.34-.75.75v5c0 .41.34.75.75.75s.75-.34.75-.75v-5c0-.41-.34-.75-.75-.75zm-.92-1.87c.05.12.12.23.21.33.1.09.21.16.33.21.24.1.52.1.76 0 .12-.05.23-.12.33-.21.09-.1.16-.21.21-.33.05-.12.08-.25.08-.38s-.03-.26-.08-.38c-.05-.13-.12-.23-.21-.33-.1-.09-.21-.16-.33-.21A.995.995 0 0012 7c-.13 0-.26.03-.38.08s-.23.12-.33.21c-.09.1-.16.2-.21.33-.05.12-.08.25-.08.38s.03.26.08.38z"
})));